import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import { MAP_LIST } from '$http';

let component = {
    const: {
        a_label: "HI幼教A政策设备预付款",
        b_label: "HI幼教B政策预付款"
    }
};

export default {
    components: {},
    props: {
        isReadOnly: {
            default () {
                return false;
            }
        },
        value: {
            default () {
                return {};
            }
        }
    },
    data() {
        return {
            isShowLbzxyfkByProjectType: false,
            isShowZqwyfk: false,
            HiPrePayMoneyLabel: component.const.a_label,
            isHideHiPrePayMoney: false,
            formData: this.getInitFormData()
        };
    },
    watch: {
        value: {
            deep: true,
            handler: function(val) {
                this.setValue();
            }
        }
    },
    methods: {
        getInitFormData() {
            return cloneDeep({
                UnionPrePayMoney: 0,
                LockHiPayMoney: "",
                LockHiPayUseMoney: "",
                HiPrePayMoney: 0,
                AccountBalance: 0,
                BookPrePayMoney: 0
            });
        },
        getRefInitFormData(Data) {
            let PolicyType = "",
                ProjectType = [];
            let agentList = Data.SignList;
            for (let i = 0; i < agentList.length; i++) {
                //PolicyType.push(agentList[i].PolicyType);
                ProjectType.push(agentList[i].SignMateriel.ProjectType);
                if ($.trim(agentList[i].PolicyTypeName).length > 0) {
                    PolicyType = agentList[i].PolicyType;
                }
            }

            let agentMoney = util.filterAndSetData(cloneDeep($.extend({}, {
                PolicyType: "",
                ProjectType: ""
            }, this.getInitFormData())), Data);
            agentMoney.PolicyType = PolicyType;
            agentMoney.ProjectType = ProjectType.join(",");
            return agentMoney;
        },
        setValue() {
            this.formData = cloneDeep($.extend({}, this.getInitFormData(), this.value));
            this.changeHiPrePayMoneyLabel({
                ProjectType: this.formData.ProjectType,
                PolicyType: this.formData.PolicyType
            });
        },
        changeHiPrePayMoneyLabel(options) {
            let opts = $.extend({}, {
                ProjectType: "", //项目类型
                PolicyType: 0 //0表示没有选这A或B政策
            }, options);

            if (opts.ProjectType.indexOf(MAP_LIST.INTENT_PROJECT[0].id) > -1) {
                this.isShowLbzxyfkByProjectType = true;
            } else {
                this.isShowLbzxyfkByProjectType = false;
            }

            if (opts.ProjectType.indexOf(MAP_LIST.INTENT_PROJECT[2].id) > -1) {
                this.isShowZqwyfk = true;
            } else {
                this.isShowZqwyfk = false;
            }

            if (opts.PolicyType === 1) {
                this.HiPrePayMoneyLabel = component.const.a_label;
            } else if (opts.PolicyType === 2) {
                this.HiPrePayMoneyLabel = component.const.b_label;
            } else if (opts.PolicyType == 0) {
                this.HiPrePayMoneyLabel = "";
            }
        },
        validate() {

            let checkRules = [];
            if (this.isShowLbzxyfkByProjectType) {
                checkRules.push({
                    name: "联帮在线预付款",
                    value: this.formData.UnionPrePayMoney,
                    required: true,
                    more0: true
                });
            }

            checkRules.push({
                name: "账户通用余额",
                value: this.formData.AccountBalance,
                required: true,
                more0: true
            });

            checkRules.push({
                name: this.HiPrePayMoneyLabel,
                value: this.formData.HiPrePayMoney,
                required: true,
                more0: true
            });

            let flag = util.checkForm({
                ele: this,
                rules: checkRules
            });
            if (!flag) {
                return false;
            }
            return util.filterAndSetData(this.getInitFormData(), this.formData);
        },
        resetFields() {
            this.formData = this.getInitFormData();
        }
    },
    computed: {
        isShowLockHiPayMoney() {
            if (this.HiPrePayMoneyLabel == component.const.a_label) {
                this.isHideHiPrePayMoney = false;
                return false;
            } else if (this.HiPrePayMoneyLabel == component.const.b_label) {
                this.isHideHiPrePayMoney = false;
            } else if ($.trim(this.HiPrePayMoneyLabel).length == 0) {
                this.isHideHiPrePayMoney = true;
                return false;
            }
            return true;
        }
    },
    mounted() {}
};


// WEBPACK FOOTER //
// ./src/common/components/agent-money/vm.js